import React from 'react';
import MoneyInput from 'components/MoneyInput';
import { useRateCalculations } from '../hooks/useRateCalculations';
import type { ClassificationSpecificInheritedSettings } from '../../types/inheritedSettings.types';

type Props = {
  source: string;
  inheritedSettings: ClassificationSpecificInheritedSettings;
};

export const BlendedRateCentsInput = ({ source, inheritedSettings }: Props) => {
  const { handlers } = useRateCalculations({ source, inheritedSettings });

  return (
    <MoneyInput
      source={`${source}.blended_rate_cents`}
      label="12hr Charge Rate"
      onChange={(event) => handlers.handleBlendedRateChange(event.target.value)}
    />
  );
};
